import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {
  BaseSiteService,
  OccEndpointsService,
  RoutingService,
  TranslationService,
  ActiveCartService
} from '@spartacus/core';
import { OrderHistoryComponent } from '@spartacus/order/components';
import { OrderFacade, ReplenishmentOrderFacade } from '@spartacus/order/root';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { combineLatest } from 'rxjs';
import * as Constants from '../../../../common/constants/CommonConstants';
import { OrderService } from '../service/order.service';
import { CartService } from 'src/app/spartacus/commonComponents/cart/cart.service';
@Component({
  selector: 'app-order-history',
  templateUrl: './order-history.component.html',
  styleUrls: ['./order-history.component.scss'],
})
export class EkOrderHistoryComponent
  extends OrderHistoryComponent
  implements OnInit {
  public orderPeriod: number = 6;
  public orderHistoryList: any = {};
  private sortArray: boolean = true;
  public maxDate: Date = new Date();
  public minDate: Date = this.getStartDate(new Date(), -this.orderPeriod);
  isOrderLoading: boolean = true;
  bsConfig: Partial<BsDatepickerConfig> | undefined;
  constructor(
    protected routing: RoutingService,
    protected userOrderService: OrderFacade,
    protected translation: TranslationService,
    protected userReplenishmentOrderService: ReplenishmentOrderFacade,
    private httpClient: HttpClient,
    private baseSite: BaseSiteService,
    private userAccount: UserAccountFacade,
    private occService: OccEndpointsService,
    private cdf: ChangeDetectorRef,
    public orderService: OrderService,
    public cartService: CartService,
    public activeCartService: ActiveCartService
  ) {
    super(
      routing,
      userOrderService,
      translation,
      userReplenishmentOrderService
    );
  }

  ngOnInit(): void {
    
    this.getAccountBasesiteData().subscribe((response) => {
      let uid = response[0]?.uid;
      if (uid && response[1]) {
        
        
        this.setRecordsToFilterByDate(response[1]);
        this.bsConfig = Object.assign({
          selectFromOtherMonth: true,
          maxDateRange: !isNaN(this.orderPeriod * 30)
            ? this.orderPeriod * 30
            : Constants.ORDER_HISTORY_PERIOD,
          containerClass: 'order-history-container',
        });
        let startDateObj = this.getStartDate(new Date(), -this.orderPeriod);
        let curDateObj = new Date();
        this.processOrderHistoryData(startDateObj, curDateObj, true);
      }
      this.cdf.detectChanges();
    });
  }

  processOrderHistoryData(
    startDateObj: Date,
    curDateObj: Date,
    pageSize: boolean
  ) {
    let stMonth = this.getMonthNum(startDateObj);
    let endMonth = this.getMonthNum(curDateObj);
    let startDate =
      startDateObj.getFullYear() +
      '-' +
      stMonth +
      '-' +
      this.getDate(startDateObj);
    let endDate =
      curDateObj.getFullYear() +
      '-' +
      endMonth +
      '-' +
      this.getDate(curDateObj);
    this.orderService.getOrderHistoryData(startDate, endDate).subscribe(
      (obj): any => {
        this.isOrderLoading = false;
        this.orderHistoryList['pagination'] = obj.pagination;
        var orders = this.groupOrderHistoryByYearMonth(obj, pageSize);
        this.orderHistoryList['orders'] = orders;
        this.orderHistoryList['sorts'] = obj.sorts;
        console.log('orderhistory', this.orderHistoryList);
        this.cdf.detectChanges();
      },
      (error) => {
        this.isOrderLoading = false;
        this.cdf.detectChanges();
      }
    );
  }

  setRecordsToFilterByDate(obj: any) {
    let recordsToShow = obj?.orderHistoryRecordsForMonths;
    recordsToShow
      ? ((this.minDate = this.getStartDate(new Date(), -recordsToShow)),
        (this.orderPeriod = recordsToShow))
      : '';
    this.cdf.detectChanges();
  }

  getAccountBasesiteData() {
    return combineLatest([
      this.userAccount.get(),
      this.baseSite.get('lipton-us'),
    ]);
  }

  groupOrderHistoryByYearMonth(data: any, pageSize: boolean) {
    var myArr: any = [];
    let totalResults = 0;
    data.orders.forEach((item: any, index: any) => {
      let dateObj = item.placed.split('T')[0].split('-');
      let year = dateObj[0];
      let month = this.getMonth(dateObj[1]) + ' ' + year;
      let monthIndex = myArr.map((e: any) => e.monthName).indexOf(month);
      if (pageSize) {
        index < 20
          ? ((item['visibility'] = true), (totalResults += 1))
          : (item['visibility'] = false); //adding visibility attribute to filter
      } else {
        item['visibility'] = true;
        totalResults += 1;
      }
      item['month'] = month; //adding month attribute to show the title
      if (monthIndex >= 0) {
        myArr[monthIndex].items.push(item);
      } else {
        myArr.push({ monthName: month, items: [item] });
      }
    });
    this.orderHistoryList.pagination
      ? (this.orderHistoryList.pagination.totalResults = totalResults)
      : '';
    return myArr;
  }

  onDateChange($event: any) {
    if ($event && $event[0] && $event[1]) {
      this.isOrderLoading = true;
      this.processOrderHistoryData($event[0], $event[1], false);
    }
  }

  sortByStatus() {
    this.sortArray
      ? this.sortAsc(this.orderHistoryList.orders, 'status')
      : this.sortDsc(this.orderHistoryList.orders, 'status');
    this.sortArray = !this.sortArray;
  }

  sortAsc(arr: any, prop: any) {
    arr.forEach((el: any) => {
      el.items.sort(function (a: any, b: any) {
        if (a[prop] < b[prop]) {
          return -1;
        } else if (a[prop] > b[prop]) {
          return 1;
        } else {
          return 0;
        }
      });
    });
  }

  sortDsc(arr: any, prop: any) {
    arr.forEach((el: any) => {
      el.items.sort(function (a: any, b: any) {
        if (a[prop] > b[prop]) {
          return -1;
        } else if (a[prop] < b[prop]) {
          return 1;
        } else {
          return 0;
        }
      });
    });
  }

  getMonthNum(dt: any): any {
    let month: any = dt.getMonth() + 1;
    return (month = month < 10 ? '0' + month : month);
  }

  getDate(dt: any): any {
    let val: any = dt.getDate();
    return (val = val < 10 ? '0' + val : val);
  }

  getMonth(val: any) {
    var monthArray = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    return monthArray[val - 1];
  }

  getStartDate(date: Date, months: number) {
    date.setMonth(date.getMonth() + months);
    return date;
  }

  redirectToOrderDeatils(orderId: string) {
    this.isOrderLoading = true;
    this.orderService.getOrderDetails(orderId).subscribe(
      (orderDetails) => {
        if (orderDetails) {
          this.isOrderLoading = false;
          this.orderService.$orderDetailsResponse.next(orderDetails);
          this.routing.goByUrl(`/my-account/order?orderId=${orderId}`);
        }
        this.cdf.detectChanges();
      },
      (error) => {
        this.isOrderLoading = false;
        this.cdf.detectChanges();
      }
    );
  }
}
